import * as React from "react";
import {
  Control,
  Controller,
  ControllerRenderProps,
  DeepMap,
  FieldError,
  UseFormRegister,
} from "react-hook-form";
import { IFormValues } from "src/components/CreateGame/CreateGame";
import { FirstStepWrapper } from "src/components/CreateGame/CreateGame.components";
import TextInput from "src/components/shared/Inputs/TextInput";
import Select from "src/components/shared/Select";
import Tooltip from "src/components/shared/Tooltip";
import { ShowCardsOptions } from "src/enums/showCards";
import { VotingOption, VotingSystemType } from "src/enums/vote/votingSystems";
interface Props {
  isGameNameErrorVisible: boolean;
  onGameNameErrorTooltipClose: () => void;
  register: UseFormRegister<IFormValues>;
  errors: DeepMap<IFormValues, FieldError>;
  control: Control<IFormValues>;
  votingSystems: VotingSystemType[] | undefined;
  votingOptions: VotingOption[];
}

const FirstStep: React.FunctionComponent<Props> = ({
  isGameNameErrorVisible,
  onGameNameErrorTooltipClose,
  register,
  errors,
  control,
  votingOptions,
  votingSystems,
}) => {
  const votingSystemSelect = ({
    onChange,
    onBlur,
    value,
  }: ControllerRenderProps<IFormValues, "votingSystem">) => (
    <Select
      label="Voting system"
      aria="Voting system"
      onChange={onChange}
      onBlur={onBlur}
      selected={!!value}
      value={value}
      options={votingOptions}
      isLoading={votingSystems?.length === 0}
    />
  );

  const showCardsSelect = ({
    onChange,
    onBlur,
    value,
  }: ControllerRenderProps<IFormValues, "showCards">) => (
    <Select
      label="Who can show cards?"
      aria="Who can show cards?"
      onChange={option => onChange(option)}
      onBlur={onBlur}
      selected={!!value}
      options={ShowCardsOptions}
      defaultValue={ShowCardsOptions[0]}
    />
  );

  return (
    <FirstStepWrapper>
      <Tooltip
        visible={isGameNameErrorVisible}
        content={
          <>
            <Tooltip.Title>Game's Name</Tooltip.Title>
            <Tooltip.Message>
              It could be project name. It'll be much easier to identify this
              task in your history.
            </Tooltip.Message>
            <Tooltip.CloseIcon onClick={onGameNameErrorTooltipClose} />
          </>
        }
        placement="right"
        fallbackPlacements={["top"]}>
        <div>
          <TextInput
            label="Game's name"
            aria="Game's name"
            register={register("gameName", {
              required: { value: true, message: "Required" },
              maxLength: { value: 24, message: "Name too long" },
            })}
            errorMessage={errors.gameName?.message}
          />
        </div>
      </Tooltip>
      <Controller
        name="votingSystem"
        control={control}
        render={({ field }) => votingSystemSelect(field)}
      />
      <Controller
        name="showCards"
        control={control}
        render={({ field }) => showCardsSelect(field)}
      />
    </FirstStepWrapper>
  );
};

export default FirstStep;
